;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[{\"path\":\"/collected/:slug\",\"regex\":\"^/collected/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/component-preview/:slug\",\"regex\":\"^/component-preview/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/mdx-preview/:slug\",\"regex\":\"^/mdx-preview/([^/]+)$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false},{\"path\":\"/registry/docs/:slug*?\",\"regex\":\"^/registry/docs(?:/(.*))?$\",\"paramNames\":[\"slug\"],\"hasOptionalPrefix\":false}],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/dev\"},{\"path\":\"/registry\"},{\"path\":\"/experiments\"},{\"path\":\"/experiments/3d-crt-display\"},{\"path\":\"/experiments/404-not-found\"},{\"path\":\"/experiments/404-not-found/article\"},{\"path\":\"/experiments/airplanes\"},{\"path\":\"/experiments/basketball-replay-center\"},{\"path\":\"/experiments/basketball-replay-center/article\"},{\"path\":\"/experiments/bugged-out-game-of-life-shader-experiment\"},{\"path\":\"/experiments/cursor-depth-explorer\"},{\"path\":\"/experiments/game-of-life-shader\"},{\"path\":\"/experiments/gravity-physics-ui-layout\"},{\"path\":\"/experiments/keyboard-keys\"},{\"path\":\"/experiments/life-3d\"},{\"path\":\"/experiments/luma-morphing\"},{\"path\":\"/experiments/mountain-transition\"},{\"path\":\"/experiments/non-euclidean-hyperbolic-workspace\"},{\"path\":\"/experiments/non-euclidean-hyperbolic-workspace/article\"},{\"path\":\"/experiments/rabbithole-chat-gallery-explore\"},{\"path\":\"/experiments/rabbithole-chat-preloader\"},{\"path\":\"/experiments/send-button\"},{\"path\":\"/experiments/terminal-cat\"},{\"path\":\"/experiments/test\"},{\"path\":\"/experiments/transit-airport-split-flap-display\"},{\"path\":\"/experiments/velocity-responsive-design\"},{\"path\":\"/experiments/velocity-responsive-design/article\"}],\"isrRoutes\":[\"/registry/docs/:slug*?\"]}";globalThis["_sentryNextJsVersion"] = "16.1.6";globalThis["_sentryRewritesTunnelPath"] = "/_t";import * as Sentry from "@sentry/nextjs";

const dsn = process.env.NEXT_PUBLIC_SENTRY_DSN;
const isDev = process.env.NODE_ENV === "development";

if (dsn) {
  Sentry.init({
    dsn,

    sendDefaultPii: false,
    enableLogs: false,

    // See console when no events show up in Sentry (e.g. DSN inlined at build time)
    debug: isDev,

    tracesSampleRate: isDev ? 1.0 : 0.1,

    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: isDev ? 1.0 : 0.1,

    // Tunnel through our origin to avoid ad-blockers (Sentry troubleshooting). Path chosen to
    // avoid block lists that match "sentry" / "monitoring" / "ingest". Must match next.config tunnelRoute.
    tunnel: "/_t",

    // View Transitions API can abort when DOM mutates during navigation (e.g. ResizeObserver in canvas demos).
    // Primary fix is deferring canvas work via requestAnimationFrame; this ignores any remaining edge cases.
    ignoreErrors: [/Transition was aborted because of invalid state/],

    // Explicit tracing + propagation (Sentry docs)
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
    ],
    tracePropagationTargets: [
      "localhost",
      /^https:\/\/[^/]*\.vercel\.app/,
      /^https:\/\/www\.razisyed\.cv/,
    ],
  });
}

export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
